import React, { useReducer, useEffect, useRef } from 'react';
// import Chip from '@material-ui/core/Chip';
// import { makeStyles } from '@material-ui/core/styles';
import { reducer, initialState, store } from './reducer';
import SearchDialog from './Dialog';
import axios from '../../../api/axios';

// const useStyles = makeStyles((theme) => ({
//   root: {
//     margin: '1px',
//     padding: theme.spacing(0, 1),
//     border: '1px solid #c3c2c2',
//     borderRadius: '4px',
//     overflowX: 'hidden',
//     display: 'flex',
//     cursor: 'pointer',
//     flexDirection: 'row-reverse',
//     justifyContent: 'flex-end',
//     '& > div:not(:first-child)': {
//       marginRight: theme.spacing(1),
//     },
//     '&:hover': {
//       border: '1px solid black',
//     },
//   },
// }));

const UsersChip = ({
  single = false,
  role,
  onChange,
  open = false,
  closeDialog,
  placeholder = 'انتخاب کاربر:',
}) => {
  // const classes = useStyles();

  const mkState = (initialState) => {
    initialState.single = single;
    role && (initialState.search.role = role);
    return initialState;
  };

  const [state, dispatch] = useReducer(reducer, initialState, mkState);
  const { users, search, page, limit, dialog } = state;
  const { Provider } = store;
  const timeoutId = useRef(null);

  const handleSearching = async () => {
    try {
      const { data: results } = await axios.post(`/api/v1/admin/users/list`, {
        page,
        limit,
        query: search,
      });
      dispatch({ type: 'RESULTS', payload: results });
    } catch (error) {}
    dispatch({ type: 'PROGRESS', payload: false });
  };

  // useEffect(() => {
  //   clearTimeout(timeoutId.current);
  //   dispatch({ type: 'PROGRESS', payload: true });
  //   timeoutId.current = setTimeout(() => handleSearching(), 2000);
  // }, [search, page, limit]);

  useEffect(() => {
    users?.length && onChange(users);
  }, [users]);
  useEffect(() => {
    open && dispatch({ type: 'OPEN_DIALOG' });
    !open && dispatch({ type: 'CLOSE_DIALOG' });
  }, [open]);
  useEffect(() => {
    if (!dialog) {
      closeDialog();
      dispatch({ type: 'REMOVE_ALL_USERS' });
    }
  }, [dialog]);

  return (
    <Provider value={{ state, dispatch }}>
      <SearchDialog
        placeholder={placeholder}
        handleSerch={handleSearching}
        fullWidth
        hideRoles={role ? true : false}
      />
    </Provider>
  );
};

export default React.memo(UsersChip);
